export class AuthException extends Error {}
